import * as React from "react"
const Pasta = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <path
      fill="#FFEA9F"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.14 9.332 8.656 7.659c4.83-1.294 8.952-1.364 9.47.568-.518-1.932 3.087-3.933 7.917-5.227l-.449 2.19 1.484 1.674-.448 2.19 1.483 1.673-.448 2.191 1.483 1.673c-4.83 1.294-8.952 1.364-9.47-.568.518 1.932-3.087 3.933-7.916 5.227l.448-2.19-1.483-1.674.448-2.19-1.484-1.673.449-2.191Z"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeWidth={2}
      d="m16.97 11.643 3.864-1.036"
    />
    <path
      fill="#FFEA9F"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.294 19.148c1.035-3.863 4.066-4.086 4.066-4.086l16.169 4.332s2.05 1.585 1.015 5.449c-1.035 3.863-3.603 4.21-3.603 4.21L4.77 24.721s-2.512-1.709-1.477-5.573Z"
    />
    <ellipse
      cx={6.675}
      cy={20.054}
      fill="#F1CA3F"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      rx={3.5}
      ry={5}
      transform="rotate(15 6.675 20.054)"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m10.504 23.15 10.625 2.848M11.54 19.287l10.624 2.847"
    />
  </svg>
)
export default Pasta
